import cn from 'classnames';
import ChevronDown from 'assets/icons/chevron-down.svg';
import type { ButtonHTMLAttributes } from 'react';
import styles from './toggle-button.module.scss';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
	isChevronUp?: boolean;
	text: string;
	variant?: 'default' | 'light';
}

export const ToggleButton = ({
	isChevronUp = false,
	text,
	variant = 'default',
	...restProps
}: Props) => {
	return (
		<button
			{...restProps}
			className={cn(styles.toggleButton, styles[variant], {
				[styles.up]: isChevronUp,
			})}
		>
			<span>{text}</span>
			<span>
				<ChevronDown />
			</span>
		</button>
	);
};
